module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-26.75fd042a.png";